<!--
 * @Description: 云途关联客户
 * @Author: cxh
 * @Date: 2023-06-25 15:11:20
 * @LastEditTime: 2023-06-25 19:21:18
 * @LastEditors: cxh
-->
<template>
  <CosModal v-model:visible="visible" title="关联客户" width="670px" @ok="handleSubmit" :confirmLoading="loading">
    <a-form :model="editForm" ref="formRef" v-if="visible" style="margin-top: 10px">
      <a-form-item name="customerName" label="客户名称" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.customerName" :disabled="true" />
      </a-form-item>
      <a-form-item name="type" label="关联客户">
        <a-radio-group v-model:value="editForm.type" :options="methods" />
      </a-form-item>
      <a-form-item
        name="customerSerial"
        v-if="editForm.type === 'customerSerial'"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="editForm.customerSerial" placeholder="请输入" @input="(e) => editForm.customerSerial = e.target.value.toUpperCase()" />
      </a-form-item>
      <a-form-item name="tmsCode" v-if="editForm.type === 'tmsCode'" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.tmsCode" placeholder="请输入" @input="(e) => editForm.tmsCode = e.target.value.toUpperCase()" />
      </a-form-item>
    </a-form>
  </CosModal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { customerRelate } from '@/api/yuntuSales/customerCenter'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = defineEmits(['success'])
const methods = [
  { label: '客户识别码', value: 'customerSerial' },
  { label: '客户代码', value: 'tmsCode' }
]
const handleSubmit = () => {
  formRef.value?.validate().then(() => {
    sure()
  })
}
const sure = async (relateConfirmFlag = false) => {
  loading.value = true
  try {
    const { type, customerSerial, tmsCode } = editForm.value
    const res = await customerRelate(
      {
        cosId: editForm.value.cosId,
        relateConfirmFlag,
        customerSerial: type === 'customerSerial' ? customerSerial : undefined,
        tmsCode: type === 'tmsCode' ? tmsCode : undefined
      },
      { custom: { errorMsg: false } }
    )
    if (res.code === 14030010) {
      DcConfirm.warning({
        title: '操作提示！',
        content: res.message,
        cancelText: '取消',
        okText: '继续',
        onOk() {
          sure(true)
        }
      })
    } else if (res.code === 200) {
      const content = type === 'customerSerial' ? customerSerial : tmsCode
      if (content) {
        DcMessage.success('关联成功')
      } else {
        DcMessage.success('取消关联成功')
      }
      emit('success')
      visible.value = false
    } else {
      DcMessage.error(res?.message)
    }
    loading.value = false
  } catch (error) {
    loading.value = false
  }
}

const toggle = (row: any) => {
  editForm.value = {
    type: 'customerSerial',
    cosId: row.cosId,
    customerSerial: row.customerSerial,
    tmsCode: row.tmsCode,
    customerName: row.customerName || '--'
  }
  visible.value = true
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'LbuRelationCustomer' }
</script>
